import script from "./WhitelistedElement.vue?vue&type=script&setup=true&lang=js"
export * from "./WhitelistedElement.vue?vue&type=script&setup=true&lang=js"

import "./WhitelistedElement.vue?vue&type=style&index=0&id=0d6159e4&lang=scss&scoped=true"

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6159e4"]])

export default __exports__